import { all, fork, put, select, takeLatest, call } from "redux-saga/effects";

import { GET_CLIENTS_LIST } from "../actions/clientsActions";
import { clientsApiProvider } from "../../lib/api/providers";

import { tokenSelector } from "../selectors/auth";
import { CLIENTS_SET_LIST } from "../types";

const getClientsApi = token => {
  return clientsApiProvider.post(`/`, {
    headers: {
      Authorization: token
    }
  });
};

function* getClients() {
  try {
    const token = yield select(tokenSelector);

    const response = yield call(getClientsApi, token);
    console.log("response : ", response);
    yield put({
      type: CLIENTS_SET_LIST,
      payload: {
        docs: response.data
      }
    });
  } catch (e) {
    console.log(e.message);
  }
}

function* watchGetClientsList() {
  yield takeLatest(GET_CLIENTS_LIST, getClients);
}

export default function* root() {
  yield all([fork(watchGetClientsList)]);
}



// WEBPACK FOOTER //
// src/redux/sagas/clientsSagas.js